import { Button } from '#atoms';
import { useState } from 'react';
import { ButtonBox, Container, Label, OptionBox, OptionItem } from './styles';

interface SortingOptionsProps {
  isSelectedOption: string;
  clickHandlerSort: (option: string) => void;
  onClose: () => void;
}

export const SortingOptions = ({
  isSelectedOption,
  clickHandlerSort,
  onClose
}: SortingOptionsProps) => {
  const [isOption, setIsOption] = useState(isSelectedOption);
  const options = [
    '최근 수업 순',
    '수업 횟수 많은 순',
    '체중 변화 많은 순',
    '체지방률 변화 많은 순',
    '골격근량 변화 많은 순'
  ];

  const onSuccess = () => {
    clickHandlerSort(isOption);
    onClose();
  };
  return (
    <Container onClick={e => e.stopPropagation()}>
      <Label>정렬</Label>
      <OptionBox>
        {options.map((option, index) => (
          <OptionItem key={index} onClick={() => setIsOption(option)}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
            >
              <rect
                width="18"
                height="18"
                fill={option === isOption ? '#7750E9' : '#383441'}
                rx="9"
                ry="9"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.5 7.5L3 9L7.5 13.5L15 6L13.5 4.5L7.5 10.5L4.5 7.5Z"
                fill={option === isOption ? 'white' : '#5C576B'}
              />
            </svg>
            {option}
          </OptionItem>
        ))}
      </OptionBox>
      <ButtonBox>
        <Button size="sm" background="anti" onClick={onClose}>
          닫기
        </Button>
        <Button size="sm" onClick={onSuccess}>
          확인
        </Button>
      </ButtonBox>
    </Container>
  );
};
